import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import CircularProgress from '@material-ui/core/CircularProgress';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     '& > * + *': {
//       marginLeft: theme.spacing(2),
//     },
//   },
//   progress: {
//     color: '#4080ff',
//   },
// }));

export default function Progress() {
  // const classes = useStyles();

  return (
    <div className={'global-loader'}>
      {/* <CircularProgress className={classes.progress} /> */}
    </div>
  );
}
